import { onMounted } from "vue";

import { ResourceRef, useResource } from "@tager/admin-services";

import { TermType } from "@/typings/model";
import { getTermList } from "@/services/requests";

export function useTermList(): ResourceRef<Array<TermType>> {
  const [fetchTermList, resource] = useResource<Array<TermType>>({
    fetchResource: getTermList,
    initialValue: [],
    resourceName: "Term list",
  });

  onMounted(() => {
    fetchTermList();
  });

  return resource;
}

export default useTermList;
